import { Doctor } from './models';
export const DOCTORS: Doctor[] = [
  {
    "slug": "doctor-cardiology-1",
    "specSlug": "cardiology",
    "specLabel": "Cardiology",
    "name": "Dr. Lim Wei Jie",
    "backLink": "cardiology",
    "backFragment": "specialists",
    "backText": "Back to Cardiology",
    "photo": "doctor-male.jpg",
    "spec": "Cardiology (Interventional)",
    "tags": [
      "18 years experience"
    ],
    "lede": "Dr. Lim has spent nearly two decades treating patients with blocked arteries and acute heart attacks. Known for explaining each option plainly, including when a procedure is not the best next step.",
    "details": [
      [
        "Speciality",
        "Cardiology (Interventional)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Cardiology)"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Melbourne"
      ],
      [
        "Experience",
        "18 years"
      ],
      [
        "Areas of expertise",
        "Coronary angioplasty and stenting, complex blockages, heart attack care, stent-versus-bypass decisions"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 41827"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-cardiology-2",
    "specSlug": "cardiology",
    "specLabel": "Cardiology",
    "name": "Dr. Nur Aisyah Rahman",
    "backLink": "cardiology",
    "backFragment": "specialists",
    "backText": "Back to Cardiology",
    "photo": "doctor-female.jpg",
    "spec": "Cardiology (Heart Failure and Prevention)",
    "tags": [
      "12 years experience"
    ],
    "lede": "Dr. Aisyah focuses on long-term heart health, helping patients review medicines, lifestyle plans and follow-up schedules so that treatment is effective and easy to follow.",
    "details": [
      [
        "Speciality",
        "Cardiology (Heart Failure and Prevention)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DNB (Cardiology)"
      ],
      [
        "Experience",
        "12 years"
      ],
      [
        "Areas of expertise",
        "Heart failure, cardiomyopathy, hypertension, cholesterol management, post-heart-attack rehabilitation"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Royal College of Physicians of Edinburgh"
      ],
      [
        "Registration",
        "Medical council registration no. 52310"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-cardiology-3",
    "specSlug": "cardiology",
    "specLabel": "Cardiology",
    "name": "Dr. Suresh Nair",
    "backLink": "cardiology",
    "backFragment": "specialists",
    "backText": "Back to Cardiology",
    "photo": "doctor-male.jpg",
    "spec": "Cardiology (Electrophysiology)",
    "tags": [
      "15 years experience"
    ],
    "lede": "Dr. Suresh specialises in heart rhythm problems and is often consulted on whether a pacemaker or ablation is truly needed.",
    "details": [
      [
        "Speciality",
        "Cardiology (Electrophysiology)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Cardiology), Fellowship in Electrophysiology"
      ],
      [
        "Education",
        "Trained at a tertiary heart centre in Singapore"
      ],
      [
        "Experience",
        "15 years"
      ],
      [
        "Areas of expertise",
        "Palpitations, atrial fibrillation, pacemakers and ICDs, syncope, echocardiogram and ECG interpretation"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 38654"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-gastroenterology-1",
    "specSlug": "gastroenterology",
    "specLabel": "Gastroenterology",
    "name": "Dr. Kenneth Ong",
    "backLink": "gastroenterology",
    "backFragment": "specialists",
    "backText": "Back to Gastroenterology",
    "photo": "doctor-male.jpg",
    "spec": "Gastroenterology (General and Therapeutic Endoscopy)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Ong has spent over a decade evaluating patients with digestive symptoms. Known for explaining what tests are truly needed, interpreting endoscopy findings in plain language and avoiding unnecessary procedures.",
    "details": [
      [
        "Speciality",
        "Gastroenterology (General and Therapeutic Endoscopy)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Gastroenterology)"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Hong Kong"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Acid reflux, ulcers, IBS, endoscopy and colonoscopy, polyp removal, bowel cancer screening, long-standing indigestion"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 42358"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-gastroenterology-2",
    "specSlug": "gastroenterology",
    "specLabel": "Gastroenterology",
    "name": "Dr. Siti Mariam Osman",
    "backLink": "gastroenterology",
    "backFragment": "specialists",
    "backText": "Back to Gastroenterology",
    "photo": "doctor-female.jpg",
    "spec": "Gastroenterology (Hepatology / Liver Diseases)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Siti Mariam focuses on liver health and helps patients understand abnormal liver reports and what they mean for the long term. Known for practical guidance on diet, lifestyle and monitoring.",
    "details": [
      [
        "Speciality",
        "Gastroenterology (Hepatology / Liver Diseases)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Gastroenterology), Fellowship in Hepatology"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "Fatty liver disease, hepatitis B and C, cirrhosis, liver function abnormalities, autoimmune liver conditions, pre-transplant evaluation"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Asian Pacific Association for the Study of the Liver"
      ],
      [
        "Registration",
        "Medical council registration no. 48127"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-gastroenterology-3",
    "specSlug": "gastroenterology",
    "specLabel": "Gastroenterology",
    "name": "Dr. Arvind Pillai",
    "backLink": "gastroenterology",
    "backFragment": "specialists",
    "backText": "Back to Gastroenterology",
    "photo": "doctor-male.jpg",
    "spec": "Gastroenterology (Inflammatory Bowel Disease and Gut Health)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Arvind works with patients who have long-term bowel conditions and helps them review medicines, flare-ups and follow-up plans. Known for clear explanations and a patient-centred approach.",
    "details": [
      [
        "Speciality",
        "Gastroenterology (Inflammatory Bowel Disease and Gut Health)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DNB (Gastroenterology), Fellowship in IBD"
      ],
      [
        "Education",
        "Trained at a gastroenterology centre in Singapore"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "Crohn's disease, ulcerative colitis, IBS, coeliac disease, chronic diarrhoea, treatment review and biologic therapy decisions"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 54480"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-mental-health-1",
    "specSlug": "mental-health",
    "specLabel": "Mental Health",
    "name": "Dr. Yeoh Pei Shan",
    "backLink": "mental-health",
    "backFragment": "specialists",
    "backText": "Back to Mental Health",
    "photo": "doctor-female.jpg",
    "spec": "Mental Health (Adult Psychiatry)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Yeoh has spent many years caring for adults with long-standing and complex mental health conditions. Known for listening closely, reviewing diagnoses and medicines carefully, and explaining options without judgement or jargon.",
    "details": [
      [
        "Speciality",
        "Mental Health (Adult Psychiatry)"
      ],
      [
        "Qualification",
        "MBBS, MD (Psychiatry)"
      ],
      [
        "Education",
        "Fellowship at a teaching hospital in Melbourne"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Depression, anxiety disorders, bipolar disorder, OCD, sleep problems, medication review, treatment-resistant conditions"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 41536"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-mental-health-2",
    "specSlug": "mental-health",
    "specLabel": "Mental Health",
    "name": "Dr. Sarah Abdullah",
    "backLink": "mental-health",
    "backFragment": "specialists",
    "backText": "Back to Mental Health",
    "photo": "doctor-female.jpg",
    "spec": "Mental Health (Clinical Psychology and Therapy)",
    "tags": [
      "13 years experience"
    ],
    "lede": "Sarah Abdullah helps patients understand their assessments and whether therapy is right for them, what it involves and how long it usually takes. Known for a warm, practical and non-judgemental approach. Note: clinical psychologists do not prescribe medicines.",
    "details": [
      [
        "Speciality",
        "Mental Health (Clinical Psychology and Therapy)"
      ],
      [
        "Qualification",
        "MA / MSc (Clinical Psychology), M.Phil (Clinical Psychology), registered clinical psychologist"
      ],
      [
        "Experience",
        "13 years"
      ],
      [
        "Areas of expertise",
        "Cognitive behavioural therapy (CBT), anxiety and stress, trauma and grief, relationship concerns, psychological assessment, therapy planning"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the British Psychological Society"
      ],
      [
        "Registration",
        "Professional registration no. 47821"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-mental-health-3",
    "specSlug": "mental-health",
    "specLabel": "Mental Health",
    "name": "Dr. Vikram Selvam",
    "backLink": "mental-health",
    "backFragment": "specialists",
    "backText": "Back to Mental Health",
    "photo": "doctor-male.jpg",
    "spec": "Mental Health (Child and Adolescent Psychiatry and De-addiction)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Vikram works with children, young people and their families and helps parents understand assessments and what support is needed at home and school. Also advises adults on recovery from alcohol and substance use.",
    "details": [
      [
        "Speciality",
        "Mental Health (Child and Adolescent Psychiatry and De-addiction)"
      ],
      [
        "Qualification",
        "MBBS, MD (Psychiatry), Fellowship in Child and Adolescent Psychiatry"
      ],
      [
        "Education",
        "Trained at a child and adolescent mental health service in Auckland"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "ADHD, autism spectrum concerns, learning and behavioural difficulties, exam stress, teenage mood and anxiety concerns, substance use and addiction recovery"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 54169"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-neurology-1",
    "specSlug": "neurology",
    "specLabel": "Neurology",
    "name": "Dr. Chong Mei Ling",
    "backLink": "neurology",
    "backFragment": "specialists",
    "backText": "Back to Neurology",
    "photo": "doctor-female.jpg",
    "spec": "Neurology (Epilepsy and Headache)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Chong has spent over a decade helping patients with seizures and long-standing headaches. Known for reviewing diagnoses carefully, simplifying medicine plans and explaining which lifestyle changes make a real difference.",
    "details": [
      [
        "Speciality",
        "Neurology (Epilepsy and Headache)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Neurology)"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Toronto"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Epilepsy and seizure management, EEG interpretation, migraine and chronic headache, medication review, drug-resistant epilepsy"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 39548"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-neurology-2",
    "specSlug": "neurology",
    "specLabel": "Neurology",
    "name": "Dr. Amir Hakim Yusof",
    "backLink": "neurology",
    "backFragment": "specialists",
    "backText": "Back to Neurology",
    "photo": "doctor-male.jpg",
    "spec": "Neurology (Stroke and Neurocritical Care)",
    "tags": [
      "13 years experience"
    ],
    "lede": "Dr. Amir focuses on stroke care, from emergency decisions to long-term prevention. Helps patients and families understand what caused a stroke and how to lower the chance of another.",
    "details": [
      [
        "Speciality",
        "Neurology (Stroke and Neurocritical Care)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Neurology), Fellowship in Stroke Medicine"
      ],
      [
        "Experience",
        "13 years"
      ],
      [
        "Areas of expertise",
        "Stroke diagnosis and prevention, recovery planning after stroke, blood pressure and risk factor control, brain scan interpretation, TIA (mini-stroke) evaluation"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Royal Australasian College of Physicians"
      ],
      [
        "Registration",
        "Medical council registration no. 46031"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-neurology-3",
    "specSlug": "neurology",
    "specLabel": "Neurology",
    "name": "Dr. Rajesh Kumar",
    "backLink": "neurology",
    "backFragment": "specialists",
    "backText": "Back to Neurology",
    "photo": "doctor-male.jpg",
    "spec": "Neurology (Movement Disorders and Memory)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Rajesh works with patients whose symptoms develop slowly and are hard to pin down. Known for patient history-taking and for explaining what a diagnosis means for daily life and long-term planning.",
    "details": [
      [
        "Speciality",
        "Neurology (Movement Disorders and Memory)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DNB (Neurology), Fellowship in Movement Disorders"
      ],
      [
        "Education",
        "Trained at a neuroscience centre in Singapore"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "Parkinson's disease, tremors, dystonia, memory loss and early dementia, neuropathy, multiple sclerosis follow-up"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 53897"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-oncology-1",
    "specSlug": "oncology",
    "specLabel": "Oncology",
    "name": "Dr. Wong Siew Lan",
    "backLink": "oncology",
    "backFragment": "specialists",
    "backText": "Back to Oncology",
    "photo": "doctor-female.jpg",
    "spec": "Oncology (Medical Oncology)",
    "tags": [
      "17 years experience"
    ],
    "lede": "Dr. Wong has spent many years planning drug treatment for patients with solid tumours. Known for reviewing reports carefully, explaining each treatment option, its benefits and side effects in plain language, and helping patients ask the right questions.",
    "details": [
      [
        "Speciality",
        "Oncology (Medical Oncology)"
      ],
      [
        "Qualification",
        "MBBS, MD (Medicine), DM (Medical Oncology)"
      ],
      [
        "Education",
        "Fellowship at a comprehensive cancer centre in Melbourne"
      ],
      [
        "Experience",
        "17 years"
      ],
      [
        "Areas of expertise",
        "Breast, lung and gastrointestinal cancers, chemotherapy planning, targeted therapy, immunotherapy, treatment review after relapse"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 37412"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-oncology-2",
    "specSlug": "oncology",
    "specLabel": "Oncology",
    "name": "Dr. Farid Hamzah",
    "backLink": "oncology",
    "backFragment": "specialists",
    "backText": "Back to Oncology",
    "photo": "doctor-male.jpg",
    "spec": "Oncology (Surgical Oncology)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Farid helps patients understand whether surgery is needed, what it involves and what recovery looks like. Known for balanced advice on timing of surgery alongside other treatments.",
    "details": [
      [
        "Speciality",
        "Oncology (Surgical Oncology)"
      ],
      [
        "Qualification",
        "MBBS, MS (General Surgery), MCh (Surgical Oncology)"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "Breast, head and neck, and gastrointestinal cancer surgery, tumour removal planning, organ-preserving surgery, review of surgical options"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the European Society for Medical Oncology"
      ],
      [
        "Registration",
        "Medical council registration no. 44906"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-oncology-3",
    "specSlug": "oncology",
    "specLabel": "Oncology",
    "name": "Dr. Priyanka Devi",
    "backLink": "oncology",
    "backFragment": "specialists",
    "backText": "Back to Oncology",
    "photo": "doctor-female.jpg",
    "spec": "Oncology (Radiation Oncology)",
    "tags": [
      "12 years experience"
    ],
    "lede": "Dr. Priyanka explains how radiation works, which type is suitable and what side effects to expect. Often consulted to review whether radiation is needed and how it fits into the overall plan.",
    "details": [
      [
        "Speciality",
        "Oncology (Radiation Oncology)"
      ],
      [
        "Qualification",
        "MBBS, MD (Radiation Oncology), Fellowship in Advanced Radiotherapy"
      ],
      [
        "Education",
        "Trained at a radiotherapy centre in London"
      ],
      [
        "Experience",
        "12 years"
      ],
      [
        "Areas of expertise",
        "Radiation planning for brain, head and neck, breast, prostate and lung cancers, advanced techniques such as IMRT and stereotactic radiotherapy, palliative radiation"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 51673"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-ophthalmology-1",
    "specSlug": "ophthalmology",
    "specLabel": "Ophthalmology",
    "name": "Dr. Ng Wei Kiat",
    "backLink": "ophthalmology",
    "backFragment": "specialists",
    "backText": "Back to Ophthalmology",
    "photo": "doctor-male.jpg",
    "spec": "Ophthalmology (Cataract and Refractive Surgery)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Ng has performed thousands of eye surgeries. Known for explaining when cataract surgery is truly needed, how different lens options compare, and what vision to realistically expect afterwards.",
    "details": [
      [
        "Speciality",
        "Ophthalmology (Cataract and Refractive Surgery)"
      ],
      [
        "Qualification",
        "MBBS, MS (Ophthalmology), Fellowship in Cataract and Refractive Surgery"
      ],
      [
        "Education",
        "Fellowship at an eye hospital in London"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Cataract surgery, intraocular lens selection, LASIK and other vision correction procedures, glasses dependence, complex cataract cases"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 40983"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-ophthalmology-2",
    "specSlug": "ophthalmology",
    "specLabel": "Ophthalmology",
    "name": "Dr. Aina Sofea Zulkifli",
    "backLink": "ophthalmology",
    "backFragment": "specialists",
    "backText": "Back to Ophthalmology",
    "photo": "doctor-female.jpg",
    "spec": "Ophthalmology (Retina and Vitreous)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Aina focuses on conditions of the retina and helps patients understand their scan findings, how urgent treatment is, and what to expect from injections, laser or surgery.",
    "details": [
      [
        "Speciality",
        "Ophthalmology (Retina and Vitreous)"
      ],
      [
        "Qualification",
        "MBBS, MS (Ophthalmology), Fellowship in Vitreo-Retinal Surgery"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "Diabetic retinopathy, macular degeneration, retinal detachment, retinal vein blockage, injections in the eye, laser treatment, OCT interpretation"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Asia-Pacific Academy of Ophthalmology"
      ],
      [
        "Registration",
        "Medical council registration no. 47158"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-ophthalmology-3",
    "specSlug": "ophthalmology",
    "specLabel": "Ophthalmology",
    "name": "Dr. Prakash Raman",
    "backLink": "ophthalmology",
    "backFragment": "specialists",
    "backText": "Back to Ophthalmology",
    "photo": "doctor-male.jpg",
    "spec": "Ophthalmology (Glaucoma and Paediatric Eye Care)",
    "tags": [
      "12 years experience"
    ],
    "lede": "Dr. Prakash works with patients who need long-term eye monitoring and helps them understand how glaucoma progresses, how treatment protects vision, and how often follow-up is needed.",
    "details": [
      [
        "Speciality",
        "Ophthalmology (Glaucoma and Paediatric Eye Care)"
      ],
      [
        "Qualification",
        "MBBS, DNB (Ophthalmology), Fellowship in Glaucoma"
      ],
      [
        "Education",
        "Trained at a children's eye centre in Singapore"
      ],
      [
        "Experience",
        "12 years"
      ],
      [
        "Areas of expertise",
        "Glaucoma diagnosis and monitoring, eye pressure management, visual field and optic nerve assessment, children's eye problems, squint, lazy eye"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 53742"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-orthopaedics-1",
    "specSlug": "orthopaedics",
    "specLabel": "Orthopaedics",
    "name": "Dr. Daniel Tan Kok Wai",
    "backLink": "orthopaedics",
    "backFragment": "specialists",
    "backText": "Back to Orthopaedics",
    "photo": "doctor-male.jpg",
    "spec": "Orthopaedics (Joint Replacement)",
    "tags": [
      "17 years experience"
    ],
    "lede": "Dr. Tan has treated thousands of patients with worn-out knees and hips. Known for explaining all options, including medicines, injections and physiotherapy, before recommending surgery.",
    "details": [
      [
        "Speciality",
        "Orthopaedics (Joint Replacement)"
      ],
      [
        "Qualification",
        "MBBS, MS (Orthopaedics), Fellowship in Joint Replacement"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Sydney"
      ],
      [
        "Experience",
        "17 years"
      ],
      [
        "Areas of expertise",
        "Knee and hip replacement, revision joint surgery, arthritis management, deciding when replacement can be delayed"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 40219"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-orthopaedics-2",
    "specSlug": "orthopaedics",
    "specLabel": "Orthopaedics",
    "name": "Dr. Hafiz Ismail",
    "backLink": "orthopaedics",
    "backFragment": "specialists",
    "backText": "Back to Orthopaedics",
    "photo": "doctor-male.jpg",
    "spec": "Orthopaedics (Spine Surgery)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Hafiz focuses on helping patients understand their MRI findings and whether their symptoms truly need an operation. Many patients are guided towards non-surgical care first.",
    "details": [
      [
        "Speciality",
        "Orthopaedics (Spine Surgery)"
      ],
      [
        "Qualification",
        "MBBS, MS (Orthopaedics), DNB, Fellowship in Spine Surgery"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "Slipped disc, sciatica, spinal stenosis, neck and back pain, minimally invasive spine surgery, non-surgical spine care"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Royal College of Surgeons of Edinburgh"
      ],
      [
        "Registration",
        "Medical council registration no. 47785"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-orthopaedics-3",
    "specSlug": "orthopaedics",
    "specLabel": "Orthopaedics",
    "name": "Dr. Kavitha Menon",
    "backLink": "orthopaedics",
    "backFragment": "specialists",
    "backText": "Back to Orthopaedics",
    "photo": "doctor-female.jpg",
    "spec": "Orthopaedics (Sports Injury and Arthroscopy)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Kavitha works with recreational and competitive athletes as well as active adults, helping them decide between repair, rehabilitation and surgery.",
    "details": [
      [
        "Speciality",
        "Orthopaedics (Sports Injury and Arthroscopy)"
      ],
      [
        "Qualification",
        "MBBS, MS (Orthopaedics), Fellowship in Arthroscopy and Sports Medicine"
      ],
      [
        "Education",
        "Trained at a sports medicine centre in London"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "ACL and ligament reconstruction, meniscus tears, shoulder instability, rotator cuff injuries, return-to-sport planning"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 55162"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-profile-1",
    "specSlug": "cardiology",
    "specLabel": "Cardiology",
    "name": "Dr. Meera Krishnan",
    "backLink": "cardiology",
    "backFragment": null,
    "backText": "Back to Cardiology",
    "photo": "doctor-female.jpg",
    "spec": "Cardiology & Interventional Cardiology",
    "tags": [
      "15+ years experience"
    ],
    "lede": "Focuses on coronary artery disease, heart failure and preventive cardiology, with a particular interest in second-opinion reviews for patients considering major cardiac procedures.",
    "details": [
      [
        "Speciality",
        "Cardiology & Interventional Cardiology"
      ],
      [
        "Qualification",
        "MBBS, MRCP (UK), Fellowship in Interventional Cardiology"
      ],
      [
        "Experience",
        "15+ years clinical experience"
      ],
      [
        "Areas of expertise",
        "Coronary artery disease, heart failure management, preventive cardiology, pre-procedure second opinions"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-profile-2",
    "specSlug": "neurology",
    "specLabel": "Neurology",
    "name": "Dr. Arjun Vellore",
    "backLink": "neurology",
    "backFragment": null,
    "backText": "Back to Neurology",
    "photo": "doctor-male.jpg",
    "spec": "Neurology",
    "tags": [
      "12+ years experience"
    ],
    "lede": "Reviews cases involving stroke, epilepsy and neurodegenerative conditions, helping patients understand diagnosis and treatment pathways before committing to a course of care.",
    "details": [
      [
        "Speciality",
        "Neurology"
      ],
      [
        "Qualification",
        "MBBS, MD (Neurology), Fellowship in Clinical Neurophysiology"
      ],
      [
        "Experience",
        "12+ years clinical experience"
      ],
      [
        "Areas of expertise",
        "Stroke & cerebrovascular disease, epilepsy, neurodegenerative conditions, diagnostic clarification"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-profile-3",
    "specSlug": "oncology",
    "specLabel": "Oncology",
    "name": "Dr. Priya Ramasamy",
    "backLink": "oncology",
    "backFragment": null,
    "backText": "Back to Oncology",
    "photo": "doctor-female.jpg",
    "spec": "Oncology",
    "tags": [
      "18+ years experience"
    ],
    "lede": "Specialises in reviewing cancer diagnoses and proposed treatment plans, giving patients a clear, independent read on their options before starting or changing treatment.",
    "details": [
      [
        "Speciality",
        "Oncology"
      ],
      [
        "Qualification",
        "MBBS, MD (Oncology), Fellowship in Medical Oncology"
      ],
      [
        "Experience",
        "18+ years clinical experience"
      ],
      [
        "Areas of expertise",
        "Diagnosis review, treatment plan evaluation, second opinions on surgery vs. non-surgical options, ongoing care coordination"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-respiratory-1",
    "specSlug": "respiratory",
    "specLabel": "Respiratory",
    "name": "Dr. Goh Hui Min",
    "backLink": "respiratory",
    "backFragment": "specialists",
    "backText": "Back to Respiratory",
    "photo": "doctor-female.jpg",
    "spec": "Respiratory Medicine (Asthma and COPD)",
    "tags": [
      "15 years experience"
    ],
    "lede": "Dr. Goh has spent over a decade helping patients manage long-term breathing conditions. Known for reviewing inhaler plans, explaining how triggers affect the lungs, and helping patients reduce flare-ups.",
    "details": [
      [
        "Speciality",
        "Respiratory Medicine (Asthma and COPD)"
      ],
      [
        "Qualification",
        "MBBS, MD (Pulmonary Medicine)"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Brisbane"
      ],
      [
        "Experience",
        "15 years"
      ],
      [
        "Areas of expertise",
        "Asthma, COPD, chronic cough, allergic airway disease, inhaler technique and review, long-term lung disease management"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 43091"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-respiratory-2",
    "specSlug": "respiratory",
    "specLabel": "Respiratory",
    "name": "Dr. Azlan Shah Karim",
    "backLink": "respiratory",
    "backFragment": "specialists",
    "backText": "Back to Respiratory",
    "photo": "doctor-male.jpg",
    "spec": "Respiratory Medicine (Interstitial Lung Disease and Interventional Pulmonology)",
    "tags": [
      "13 years experience"
    ],
    "lede": "Dr. Azlan focuses on complex lung conditions and helps patients understand their scan findings and whether further tests or procedures are truly needed.",
    "details": [
      [
        "Speciality",
        "Respiratory Medicine (Interstitial Lung Disease and Interventional Pulmonology)"
      ],
      [
        "Qualification",
        "MBBS, MD (Pulmonary Medicine), DM (Pulmonary and Critical Care), Fellowship in Bronchoscopy"
      ],
      [
        "Experience",
        "13 years"
      ],
      [
        "Areas of expertise",
        "Interstitial lung disease, pulmonary fibrosis, bronchoscopy, lung nodules, pleural effusion, CT chest interpretation"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the European Respiratory Society"
      ],
      [
        "Registration",
        "Medical council registration no. 49764"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-respiratory-3",
    "specSlug": "respiratory",
    "specLabel": "Respiratory",
    "name": "Dr. Deepa Krishnan",
    "backLink": "respiratory",
    "backFragment": "specialists",
    "backText": "Back to Respiratory",
    "photo": "doctor-female.jpg",
    "spec": "Respiratory Medicine (Sleep Medicine and Infections)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Deepa works with patients whose breathing problems affect sleep and daily energy, and helps them understand sleep study results and whether device therapy is needed.",
    "details": [
      [
        "Speciality",
        "Respiratory Medicine (Sleep Medicine and Infections)"
      ],
      [
        "Qualification",
        "MBBS, MD (Pulmonary Medicine), Fellowship in Sleep Medicine"
      ],
      [
        "Education",
        "Trained at a sleep medicine centre in Singapore"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "Sleep apnoea, snoring, CPAP and BiPAP therapy review, tuberculosis, recurrent chest infections, post-COVID breathlessness"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 55839"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-urology-1",
    "specSlug": "urology",
    "specLabel": "Urology",
    "name": "Dr. Jason Lee Chee Keong",
    "backLink": "urology",
    "backFragment": "specialists",
    "backText": "Back to Urology",
    "photo": "doctor-male.jpg",
    "spec": "Urology (Stones and Endourology)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Lee has treated thousands of patients with kidney stones. Known for explaining whether a stone needs surgery or can be managed with medicines and fluids, and for practical advice on stopping stones from returning.",
    "details": [
      [
        "Speciality",
        "Urology (Stones and Endourology)"
      ],
      [
        "Qualification",
        "MBBS, MS (General Surgery), MCh (Urology)"
      ],
      [
        "Education",
        "Fellowship at a university hospital in Adelaide"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Kidney and ureteric stones, laser stone surgery (RIRS, URS), PCNL, recurrent stones, stone prevention advice, urinary tract blockage"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 41275"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-urology-2",
    "specSlug": "urology",
    "specLabel": "Urology",
    "name": "Dr. Faizal Hamid",
    "backLink": "urology",
    "backFragment": "specialists",
    "backText": "Back to Urology",
    "photo": "doctor-male.jpg",
    "spec": "Urology (Uro-Oncology and Robotic Surgery)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Faizal helps patients understand reports related to urological cancers and what treatments, including active monitoring, are suitable. Known for balanced advice on timing and type of surgery.",
    "details": [
      [
        "Speciality",
        "Urology (Uro-Oncology and Robotic Surgery)"
      ],
      [
        "Qualification",
        "MBBS, MS (General Surgery), MCh (Urology), Fellowship in Robotic Surgery"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "Prostate, kidney and bladder cancers, raised PSA and biopsy decisions, robotic and laparoscopic surgery, organ-preserving surgery"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Urological Association of Asia"
      ],
      [
        "Registration",
        "Medical council registration no. 46852"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-urology-3",
    "specSlug": "urology",
    "specLabel": "Urology",
    "name": "Dr. Anand Subramaniam",
    "backLink": "urology",
    "backFragment": "specialists",
    "backText": "Back to Urology",
    "photo": "doctor-male.jpg",
    "spec": "Urology (Prostate, Men's Health and Reconstructive Urology)",
    "tags": [
      "11 years experience"
    ],
    "lede": "Dr. Anand works with patients dealing with sensitive and long-standing urinary and men's health concerns, and provides clear, respectful guidance on medicines, procedures and lifestyle changes.",
    "details": [
      [
        "Speciality",
        "Urology (Prostate, Men's Health and Reconstructive Urology)"
      ],
      [
        "Qualification",
        "MBBS, MS (General Surgery), DNB (Urology)"
      ],
      [
        "Education",
        "Trained at a urology centre in Singapore"
      ],
      [
        "Experience",
        "11 years"
      ],
      [
        "Areas of expertise",
        "Enlarged prostate (BPH), urinary flow problems, urethral stricture, male infertility, erectile dysfunction, incontinence, recurrent urinary infections"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 53316"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-womens-health-1",
    "specSlug": "womens-health",
    "specLabel": "Women's Health",
    "name": "Dr. Tan Li Ying",
    "backLink": "womens-health",
    "backFragment": "specialists",
    "backText": "Back to Women's Health",
    "photo": "doctor-female.jpg",
    "spec": "Women's Health (Gynaecology and Minimally Invasive Surgery)",
    "tags": [
      "16 years experience"
    ],
    "lede": "Dr. Tan has treated thousands of women with gynaecological conditions. Known for explaining whether surgery is truly needed, which alternatives exist, and what recovery looks like, with a focus on preserving the uterus where appropriate.",
    "details": [
      [
        "Speciality",
        "Women's Health (Gynaecology and Minimally Invasive Surgery)"
      ],
      [
        "Qualification",
        "MBBS, MS (Obstetrics and Gynaecology), Fellowship in Minimal Access Surgery"
      ],
      [
        "Education",
        "Fellowship at a women's hospital in Melbourne"
      ],
      [
        "Experience",
        "16 years"
      ],
      [
        "Areas of expertise",
        "Fibroids, ovarian cysts, endometriosis, heavy periods, hysterectomy decisions, laparoscopic and hysteroscopic surgery, pelvic pain"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Mandarin"
      ],
      [
        "Registration",
        "Medical council registration no. 42617"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-womens-health-2",
    "specSlug": "womens-health",
    "specLabel": "Women's Health",
    "name": "Dr. Nurul Izzah Hassan",
    "backLink": "womens-health",
    "backFragment": "specialists",
    "backText": "Back to Women's Health",
    "photo": "doctor-female.jpg",
    "spec": "Women's Health (Obstetrics and High-Risk Pregnancy)",
    "tags": [
      "14 years experience"
    ],
    "lede": "Dr. Nurul Izzah helps expectant mothers understand their reports and options at each stage of pregnancy. Known for calm, clear guidance that helps families make informed decisions.",
    "details": [
      [
        "Speciality",
        "Women's Health (Obstetrics and High-Risk Pregnancy)"
      ],
      [
        "Qualification",
        "MBBS, MD (Obstetrics and Gynaecology), DNB, Fellowship in Maternal-Fetal Medicine"
      ],
      [
        "Experience",
        "14 years"
      ],
      [
        "Areas of expertise",
        "High-risk pregnancy, gestational diabetes, pregnancy-related high blood pressure, recurrent miscarriage, delivery planning, caesarean versus normal delivery decisions"
      ],
      [
        "Consultation mode",
        "Video consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia"
      ],
      [
        "Memberships",
        "Member of the Royal College of Obstetricians and Gynaecologists"
      ],
      [
        "Registration",
        "Medical council registration no. 48390"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  },
  {
    "slug": "doctor-womens-health-3",
    "specSlug": "womens-health",
    "specLabel": "Women's Health",
    "name": "Dr. Lakshmi Rajan",
    "backLink": "womens-health",
    "backFragment": "specialists",
    "backText": "Back to Women's Health",
    "photo": "doctor-female.jpg",
    "spec": "Women's Health (Fertility, PCOS and Menopause)",
    "tags": [
      "12 years experience"
    ],
    "lede": "Dr. Lakshmi works with women and couples at sensitive stages of life and focuses on explaining tests, treatment options, success rates and realistic timelines, without pressure to start treatment.",
    "details": [
      [
        "Speciality",
        "Women's Health (Fertility, PCOS and Menopause)"
      ],
      [
        "Qualification",
        "MBBS, MS (Obstetrics and Gynaecology), Fellowship in Reproductive Medicine"
      ],
      [
        "Education",
        "Trained at a fertility centre in Singapore"
      ],
      [
        "Experience",
        "12 years"
      ],
      [
        "Areas of expertise",
        "Infertility evaluation, PCOS, irregular periods, IUI and IVF counselling, hormone therapy, perimenopause and menopause care"
      ],
      [
        "Consultation mode",
        "Video consultation, phone consultation, written report review"
      ],
      [
        "Languages",
        "English, Bahasa Malaysia, Tamil"
      ],
      [
        "Registration",
        "Medical council registration no. 55274"
      ]
    ],
    "noteTitle": "Before you start your case",
    "noteText": "Submitting a case doesn't book this specific doctor. Your case is reviewed by whichever specialist is the best clinical fit — it may be this doctor, or another verified specialist in the same field."
  }
];
